export const actionCableUrl = (): string =>
  (document.querySelector("meta[name=action-cable-url]") as HTMLMetaElement)
    .content;

export const fobizzHocuspocusWebsocketUrl = (): string =>
  (document.querySelector("meta[name=fobizz-hocuspocus]") as HTMLMetaElement)
    .content;

export const csrfToken = (): string =>
  (document.querySelector("meta[name=csrf-token]") as HTMLMetaElement).content;

export const getMetaTagContent = (name: string): string | undefined => {
  const element = document.head.querySelector(
    `meta[name="${name}"]`
  ) as HTMLMetaElement;
  return element?.content;
};
